/**
 * Liczba mnoga po polsku.
 *
 * Polski ma TRZY formy, nie dwie: 1 akt, 2 akty, 5 aktów. Warunek `n === 1 ? a : b`
 * daje „2 aktów" i „3 pozycji" — w dokumencie wręczanym klientowi czyta się to jak usterka.
 */

/**
 * @param one   forma dla 1 (np. „akt")
 * @param few   forma dla 2–4 oraz końcówek 2–4 poza 12–14 (np. „akty")
 * @param many  pozostałe, w tym 0 i 12–14 (np. „aktów")
 */
export function pluralPl(count: number, one: string, few: string, many: string): string {
  const n = Math.abs(Math.trunc(count));
  if (n === 1) return one;
  const lastTwo = n % 100;
  // 12, 13, 14 mimo końcówki 2/3/4 biorą formę „wiele" — to jedyny wyjątek w tej regule.
  if (lastTwo >= 12 && lastTwo <= 14) return many;
  const last = n % 10;
  return last >= 2 && last <= 4 ? few : many;
}

/** Najczęstszy przypadek w wycenie: akty notarialne z RCN. Formy są tekstem dla użytkownika. */
export const pluralActs = (count: number) => pluralPl(count, "akt", "akty", "aktów");
